import { useState } from "react"

import Toast from "../../components/Toast/Toast"

type ToastState = {
  title: string
  type: "success" | "error" | "default"
  description?: string
  isVisible: boolean
}

type ShowToastParams = {
  type: "success" | "error"
  title: string
  description?: string
}

const useToast = () => {
  const [toastState, setToastState] = useState<ToastState>({
    title: "",
    type: "default",
    description: "",
    isVisible: false
  })

  const showToastMessage = ({ type, title, description }: ShowToastParams) => {
    setToastState({
      type,
      title,
      description,
      isVisible: true
    })
  }

  const closeToast = () => {
    setToastState({
      title: "",
      type: "default",
      description: "",
      isVisible: false
    })
  }

  const toastComponent = toastState.isVisible && (
    <Toast
      type={toastState.type}
      title={toastState.title}
      description={toastState.description}
      onClose={closeToast}
    />
  )

  return { showToastMessage, toastComponent }
}

export default useToast
